import { useState } from 'react'
import { useModalBrokerInvitationStore } from '../../../../store/modals-services/modal-broker-invitation'
import { postHandleInvitationCollaborators } from '../../../../services/invitations-services'
import { useAmplitude } from '../../../../../analytics/src/providers/amplitud-provider/AmplitudeProvider'
import { EWCAmplitude } from '../../../../enums/amplitude-events'

export const useModalBrokerInvitation = () => {
  const { isInitialized, trackEvent } = useAmplitude()
  const { isOpen, setIsOpen, setStatus, status, invitationData } =
    useModalBrokerInvitationStore()
  const [isLoading, setIsLoading] = useState(false)
  const [isError, setIsError] = useState<string | undefined>(undefined)
  const [isSuccessDeclined, setIsSuccessDeclined] = useState(false)

  const isOpenModal = Boolean(isOpen && invitationData)

  const onCloseModal = () => {
    setIsOpen({
      isOpen: false,
      status: undefined,
      invitationData: undefined,
      brokerAgencyRequestExists: undefined
    })
  }

  const handleDeclined = async () => {
    setIsLoading(true)
    setIsError(undefined)
    try {
      const { isSuccess, errorMessage } =
        await postHandleInvitationCollaborators({
          inviteId: invitationData?.inviteId || '',
          usage: 'declined'
        })

      if (isSuccess) {
        if (isInitialized) {
          trackEvent({
            name: EWCAmplitude.WC_SIGNUP_CANCEL_REQUEST_INVITE
          })
        }

        setIsSuccessDeclined(true)
        setTimeout(() => {
          onCloseModal()
        }, 2000)
      } else {
        setIsError(errorMessage || 'Ocurrio un error al cancelar la solicitud')
      }
    } catch {
      setIsError('Ocurrio un error al cancelar la solicitud')
    } finally {
      setIsLoading(false)
    }
  }

  const permanentHiddenModal = () => {
    postHandleInvitationCollaborators({
      inviteId: invitationData?.inviteId || '',
      statusAccepted: true
    })
  }

  return {
    isOpenModal,
    setIsOpen,
    setStatus,
    status,
    onCloseModal,
    isLoading,
    isError,
    handleDeclined,
    isSuccessDeclined,
    permanentHiddenModal
  }
}
